import React from "react";

export default class Download extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileTitle: [],
      fileName: [],
      description: null,
      group: null,
    };
  }

  componentWillReceiveProps(props) {
    let { product } = props;
    let { fileTitle, fileName, description, group } = this.state;
    let productName = product.name;
    this.props.dataApi.fetchDownloadData(
      function (response) {
        fileTitle = response[productName]["file_title"];
        fileName = response[productName]["file_name"];
        group = response[productName]["group"];
        if (response[productName].hasOwnProperty("description")) {
          description = response[productName]["description"];
        } else {
          description = null;
        }
        this.setState({ fileTitle, fileName, description, group });
      }.bind(this)
    );
  }

  componentDidMount() {
    let { product } = this.props;
    let { fileTitle, fileName, description, group } = this.state;
    let productName = product.name;
    this.props.dataApi.fetchDownloadData(
      function (response) {
        fileTitle = response[productName]["file_title"];
        fileName = response[productName]["file_name"];
        group = response[productName]["group"];
        if (response[productName].hasOwnProperty("description")) {
          description = response[productName]["description"];
        } else {
          description = null;
        }
        this.setState({ fileTitle, fileName, description, group });
      }.bind(this)
    );
  }

  render() {
    const { product, translationData } = this.props;
    let { fileTitle, fileName, description, group } = this.state;
    const imgSrc = "assets/images/company/" + product.logo;
    const pdfSrc = "assets/pdf/";
    let lastMinusThirdFileTitle = null;
    let lastMinusThirdFileName = null;

    if ("prolia" === product.name) {
      lastMinusThirdFileTitle = fileTitle[fileTitle.length - 3];
      lastMinusThirdFileName = fileName[fileName.length - 3];
    }
    
    let lastBeforeFileTitle = fileTitle[fileTitle.length - 2];
    let lastBeforeFileName = fileName[fileName.length - 2];
    let lastFileTitle = fileTitle[fileTitle.length - 1];
    let lastFileName = fileName[fileName.length - 1];

    return (
      <div className="row">
        <div className="row-no-margin">
          <div className="selected-product-logo">
            <img src={imgSrc} className="img-responsive" alt="" />
          </div>
          {((group) => {
            switch (group) {
              default:
              case 0:
                return (
                  <div className="download-apply">
                    <a  href='https://asnfapply.com/'
                        target='_blank'
                        className="btn btn-default semibold process-prev">
                        {translationData.applyOnline}
                        <img src="/assets/images/external_link_icon.svg" className="external" />
                    </a>
                  </div>
                );
              case 1:
                return (
                  <div className="download-content row-eq-height" style={{justifyContent: 'center' }}>
                    <div className="col-md-8 download-step">
                      <p className="step-title">
                        {translationData.download.step1}
                      </p>
                      <p
                        className="step-comment"
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                    </div>
                    <div className="col-md-4 download-step">
                      <p className="step-title">
                        {translationData.download.step3}
                      </p>
                      {null !== lastMinusThirdFileTitle ? (
                        <a
                          className="download-link"
                          rel="noopener noreferrer"
                          href={pdfSrc + lastMinusThirdFileName}
                          target="_blank"
                        >
                          {lastMinusThirdFileTitle}
                        </a>
                      ) : null}
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastBeforeFileName}
                        target="_blank"
                      >
                        {lastBeforeFileTitle}
                      </a>
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastFileName}
                        target="_blank"
                      >
                        {lastFileTitle}
                      </a>
                    </div>
                  </div>
                );
              case 3:
                return (
                  <div className="download-content row-eq-height" style={{justifyContent: 'center' }}>
                    <div className="col-md-4 col-md-offset-4 download-step single-column">
                      <p className="step-title">
                        {translationData.download.step3}
                      </p>
                      {null !== lastMinusThirdFileTitle ? (
                        <a
                          className="download-link"
                          rel="noopener noreferrer"
                          href={pdfSrc + lastMinusThirdFileName}
                          target="_blank"
                        >
                          {lastMinusThirdFileTitle}
                        </a>
                      ) : null}
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastBeforeFileName}
                        target="_blank"
                      >
                        {lastBeforeFileTitle}
                      </a>
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastFileName}
                        target="_blank"
                      >
                        {lastFileTitle}
                      </a>
                    </div>
                  </div>
                );
            }
          })(group)}
        </div>
      </div>
    );
  }
}
